import { TAutobiddersFiltersSchema } from 'apps/spot-quote-control-panel/schema/AutobiddersFiltersSchema'
import { appliedFilterLabels } from '../constants/autobidderConfig'

export const appliedFilterNames = (filters: TAutobiddersFiltersSchema): string => {
  const appliedFilters = []
  for (const key in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, key)) {
      const filter = filters[key as keyof TAutobiddersFiltersSchema]
      if (filter !== null && filter?.toString() !== [].toString()) {
        appliedFilters.push(appliedFilterLabels[key as keyof typeof appliedFilterLabels])
      }
    }
  }
  return appliedFilters.join(', ')
}
